import { useRecoilState } from 'recoil';
import { organizationConfigAtom } from 'services/organization/atom';
import { useUpsertOrganizationConfigMutation } from 'generated-graphql/hooks/apollo-hooks';

export const useSetDefaultTemplate = () => {
  const [organizationConfig, setOrganizationConfig] = useRecoilState(
    organizationConfigAtom
  );
  const [upsertOrganizationConfigMutation] =
    useUpsertOrganizationConfigMutation();

  const setDefaultTemplate = async (templateId: string) => {
    const result = await upsertOrganizationConfigMutation({
      variables: {
        input: {
          defaultAutomationTaskTemplateId: templateId
        }
      }
    });

    const updatedOrganizationConfig = result.data?.upsertOrganizationConfig;

    if (updatedOrganizationConfig) {
      setOrganizationConfig((prevConfig) =>
        prevConfig
          ? {
              ...prevConfig,
              defaultAutomationTaskTemplateId:
                updatedOrganizationConfig.defaultAutomationTaskTemplateId
            }
          : updatedOrganizationConfig
      );
    }

    return result;
  };

  return { setDefaultTemplate, organizationConfig };
};
